// extracted by mini-css-extract-plugin
export var actions = "styles-module--actions--d9da6";
export var card = "styles-module--card--28044";
export var content = "styles-module--content--6d8e4";
export var header = "styles-module--header--44dc0";
export var hiddenActions = "styles-module--hiddenActions--484eb";
export var kitQuantity = "styles-module--kitQuantity--eed93";
export var quantities = "styles-module--quantities--ed916";
export var quantityInput = "styles-module--quantityInput--efbe3";
export var reorder = "styles-module--reorder--bd135";
export var title = "styles-module--title--ae069";